export default __webpack_public_path__ + "static/media/svg-3.b2e882a7.svg";